/* eslint react/prop-types:0 */
import React from 'react';
import PropTypes from 'prop-types';

import { Screen } from '@confluence/screen';
import { MainLayout } from '@confluence/main-layout';
import { CustomContentOnPageComponentLoader } from '@confluence/custom-content-page/entry-points/CustomContentOnPageComponentLoader';
import { CONTAINER_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs';

export const CustomContentOnPageRoute = ({ name, params: { contentId, spaceKey, type } }) => {
	return (
		<Screen
			screenEvent={{
				name: 'customContentOnPage',
				id: contentId,
			}}
			pageState={{
				routeName: name,
				spaceKey,
				contentId,
			}}
		>
			<MainLayout spaceKey={spaceKey} navView={CONTAINER_HOME_ID}>
				<CustomContentOnPageComponentLoader
					contentId={contentId}
					spaceKey={spaceKey}
					type={type === 'undefined' ? '' : type}
				/>
			</MainLayout>
		</Screen>
	);
};

CustomContentOnPageRoute.propTypes = {
	params: PropTypes.shape({
		contentId: PropTypes.string,
		spaceKey: PropTypes.string,
		type: PropTypes.string,
	}),
};
